import { useQuery } from 'hooks/useCustomQuery';
import { getAvailNumberblocks } from 'API/Numbers/getAvailNumberblocks';

/**
 * (3154) Public pool number blocks the wholesaler has made available to the
 * company — what the Numbers page's Available Number Blocks drawer lists.
 */
const useGetAvailableNumberBlocks = (companyId, options = {}) =>
    useQuery({
        queryKey: ['setupProgress', 'availableNumberBlocks', companyId],
        queryFn: async () => (await getAvailNumberblocks(companyId)) || [],
        enabled: !!companyId,
        refetchOnWindowFocus: false,
        retry: false,
        ...options,
    });

export default useGetAvailableNumberBlocks;
